<div class="flex align-items-center gap-2 p-3 border-top-1 surface-border">
  <input
    pInputText
    type="text"
    class="flex-1 min-w-0"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [ngModel]="texto()"
    (ngModelChange)="texto.set($event)"
    (keyup.enter)="onEnviar()"
    autocomplete="off"
    aria-label="Mensaje"
  />

  <p-button
    type="button"
    icon="pi pi-send"
    ariaLabel="Enviar mensaje"
    [disabled]="!puedeEnviar()"
    (onClick)="onEnviar()"
  />
</div>
